import * as React from 'react';

import {Button} from '../../button/button';
import {ButtonMover} from '../../button-mover/button-mover';
import {ChevronLeftIcon} from '../../icon';
import {StackLegacy} from '../../layout/stack/stack-legacy';

import styles from './sub-sidebar-header.module.css';

type Props = {
    title: string;
    subtitle?: string | React.ReactNode;
    onClickBack: () => void;
    getRef?: any;
    noShadow?: boolean;
};

export function SubSidebarHeader(props: Props) {
    return (
        <div
            ref={props.getRef}
            className={
                props.noShadow
                    ? styles['sub-sidebar-header--no-shadow']
                    : styles['sub-sidebar-header']
            }
        >
            <ButtonMover size='big' direction={['left', 'up']}>
                <Button onClick={props.onClickBack} variant='text-secondary' size='big'>
                    <StackLegacy spacing={8} isHorizontal={true} alignCenter={true}>
                        <ChevronLeftIcon size={15} wrapWithDiv={false} />
                        <div>Back</div>
                    </StackLegacy>
                </Button>
            </ButtonMover>
            <div className={styles['header-text-container']}>
                <div className={styles.title}>{props.title}</div>
                {props.subtitle && <div className={styles.subtitle}>{props.subtitle}</div>}
            </div>
        </div>
    );
}
